export abstract class TagManagerBase {
  abstract pushTag(infos: any);
  abstract usable();
}
